import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { ComponetArray } from "./ComponentArray";
import { BsArrowLeftCircleFill } from "react-icons/bs";
import AuthService from "../../session/AuthService";

class OwnerPerformancingData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      description: "",
      title: "",
      totalvalue: {},
      exactadata: {},
      contentPage: false,
      clickedIndex: false,
    };
  }

  render() {
    console.log("props", this.props);
    const { clickedIndex } = this.state;


    return (
      
      
          <>
           {AuthService.getUserTypeAdmin() === "3" && (
           <span className="cursor-pointer" style={{position : "relative" , padding : "35px" , top : "12px"}}>
           <BsArrowLeftCircleFill style={{ color: "rgb(138, 188, 73)", fontSize: "30px" }}  onClick={this.backToForm}/>
              </span>
         )} 
            <div className="card-container-2">
              {ComponetArray.map((item, index) => (
                <div
                  className={`card${clickedIndex === index ? "clicked" : "-2"} cursor-pointer`}
                  key={index}
                  onClick={() => this.handleClick2(item, index)}
                >
                  {/* Image icon */}
                  <img src={item.icon} alt="Icon" />

                  {/* Text content */}
                  <h2>{item.name}</h2>

                  {/* Add more content here if needed */}
                </div>
              ))}
            </div>
          </>
        
      
    );
  }


  backToForm = () => {

    this.props.history.replace(`/Employers`);
  }



  handleClick2 = (item) => {
    console.log("item name:", item.name);
  
  
    this.setState({
      clickedIndex : item
    },() => {

      this.props.history.replace(`/${item.name}`);

    })

    
  };
}

const mapStateToProps = function (state) {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(OwnerPerformancingData));
